<template>
  <v-navigation-drawer id="appDrawer" clipped app v-model="drawer">
    <div style="padding: 20px;" class="hidden-lg-and-up">
      <v-img
        :to="{ name: 'Dashboard' }"
        max-height="30"
        contain
        :src="computeLogo"
      ></v-img>
    </div>
    <!-- <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings"> -->
    <v-list dense expand>
      <template v-for="(item, i) in menus">
        <!--group with subitems-->
        <v-list-group
          v-if="item.items"
          :key="item.name"
          :group="item.group"
          :prepend-icon="item.icon"
          no-action="no-action"
        >
          <v-list-item-action slot="activator" ripple="ripple">
            {{ item.title }}
          </v-list-item-action>
          <template v-for="(subItem, i) in item.items">
            <!--sub group-->
            <v-list-group
              v-if="subItem.items"
              :key="subItem.name"
              :group="subItem.group"
              sub-group="sub-group"
            >
              <v-list-item-action>
                {{ subItem.title }}
              </v-list-item-action>

              <v-list-item-action
                v-for="(grand, i) in subItem.children"
                :key="i"
                :to="genChildTarget(item, grand)"
                :href="grand.href"
                ripple="ripple"
              >
                {{ grand.title }}
              </v-list-item-action>
            </v-list-group>
            <!--child item-->
            <v-list-item
              v-else
              :key="i"
              :to="genChildTarget(item, subItem)"
              :href="subItem.href"
              :disabled="subItem.disabled"
              :target="subItem.target"
              ripple="ripple"
            >
              <v-list-item-action>
                <span>{{ subItem.title }}</span>
              </v-list-item-action>
              <v-list-item-action v-if="subItem.action">
                <v-icon :class="[subItem.actionClass || 'success--text']">{{
                  subItem.action
                }}</v-icon>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list-group>
        <v-subheader v-else-if="item.header" :key="i">{{
          item.header
        }}</v-subheader>
        <v-divider v-else-if="item.divider" :key="i"></v-divider>
        <!--top-level link-->
        <v-list-item
          v-else
          :to="!item.href ? { name: item.name } : null"
          :href="item.href"
          ripple="ripple"
          :disabled="item.disabled"
          :target="item.target"
          rel="noopener"
          :key="item.name"
        >
          <v-list-item-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
    <!-- </vue-perfect-scrollbar>         -->
  </v-navigation-drawer>
</template>
<script>
import menu from "@/api/menu";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
  name: "app-drawer",
  components: {
    VuePerfectScrollbar
  },
  props: {
    expanded: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    mini: false,
    drawer: false,
    menus: menu,
    scrollSettings: {
      maxScrollbarLength: 160
    }
  }),
  computed: {
    computeGroupActive() {
      return true;
    },
    computeLogo() {
      return "/static/logo-ecotrace-a.png";
    },

    sideToolbarColor() {
      return this.$vuetify.options.extra.sideNav;
    }
  },
  created() {
    window.getApp.$on("APP_DRAWER_TOGGLED", () => {
      this.drawer = !this.drawer;
    });
  },

  methods: {
    genChildTarget(item, subItem) {
      if (subItem.href) return;
      if (subItem.component) {
        return {
          name: subItem.component
        };
      }
      return { name: `${item.group}/${subItem.name}` };
    }
  }
};
</script>

<style lang="stylus">
// @import '../../node_modules/vuetify/src/stylus/settings/_elevations.styl';

// #appDrawer
//   overflow: hidden
//   .drawer-menu--scroll
//     height: calc(100vh - 48px)
//     overflow: auto


.v-list-item {
    font-size: .8125rem;
    font-weight: 500;
    line-height: 1rem;
}
</style>
